const ArrowRight = ({ className }: { className?: string }) => {
  return (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1213_926)">
        <circle cx="23" cy="23" r="16" fill={className ?? 'white'} fillOpacity="0.75" shapeRendering="crispEdges" />
      </g>
      <mask
        id="mask0_1213_926"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="8"
        y="7"
        width="33"
        height="32"
      >
        <rect x="8.6001" y="7" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1213_926)">
        <path
          d="M26.6001 23L20.4668 16.8667L21.1335 16.2L27.9335 23L21.1335 29.8L20.4668 29.1333L26.6001 23Z"
          fill="black"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1213_926"
          x="0"
          y="0"
          width="46"
          height="46"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1213_926" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1213_926" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default ArrowRight;
